// Feature: Delivery - Service Layer
// Location: src/features/delivery/services/deliveryService.ts
//
// Business logic wrapper over orderApi. Components import from here.

import * as orderApi from './orderApi';
import type { CreateOrderBody } from 'types/api.generated';
import type { Order, ListOrdersResponse, OrderStatus } from 'types/delivery.types';

export const deliveryService = {
  /** Create a new delivery order. Validates required fields before submitting. */
  placeOrder: async (data: CreateOrderBody): Promise<Order> => {
    return orderApi.createOrder(data);
  },

  /** Fetch the current user's order history with optional pagination / status filter. */
  getOrders: async (params?: {
    page?: number;
    perPage?: number;
    status?: OrderStatus;
  }): Promise<ListOrdersResponse> => {
    return orderApi.listOrders(params);
  },

  /** Get full details for a single order (customer view). */
  getOrderById: async (id: string): Promise<Order> => {
    return orderApi.getOrder(id);
  },

  /** Cancel an order that is still in a cancellable state (pending / accepted). */
  cancelOrder: async (id: string): Promise<void> => {
    return orderApi.cancelOrder(id);
  },
};
